import { sortAsc } from '@strata/helper-functions';
import { FormInputContainer } from '@strata/react-form-input-container';
import { DetailLabelList } from '@strata/react-label-value-pairs';
import classNames from 'classnames';
import { Fragment } from 'react';

interface ClaimCodesContainerProps {
    categories: {
        label: string;
        codes?: {
            code: string;
            description: string;
            code2?: string;
            description2?: string;
        }[];
    }[];
    className?: string;
}

export const ClaimCodesContainer = ({
    categories,
    className = undefined,
}: ClaimCodesContainerProps) => {
    const categoriesToDisplay = categories.filter((category) => (category.codes ?? []).length > 0);
    return categoriesToDisplay.length > 0 ? (
        <FormInputContainer className={classNames('sds_claim-codes-container', className)}>
            {categoriesToDisplay.map((category) => (
                <DetailLabelList
                    key={category.label}
                    label={category.label}
                    values={[...category.codes!]
                        .sort((a, b) =>
                            sortAsc(`${a.code}${a.description}`, `${b.code}${b.description}`),
                        )
                        .map((code) => (
                            <Fragment key={`${code.code}${code.code2}`}>
                                {code.code}
                                <span className="sds_claim-codes-container__code-description">
                                    {` - ${code.description}${code.code2 ? ', ' : ''}`}
                                </span>
                                {code.code2 && (
                                    <span>
                                        {code.code2}
                                        <span className="sds_claim-codes-container__code-description">{` - ${code.description2}`}</span>
                                    </span>
                                )}
                            </Fragment>
                        ))}
                />
            ))}
        </FormInputContainer>
    ) : null;
};
